import { render, staticRenderFns } from "./WorkspaceSigChainRunCard.vue?vue&type=template&id=42321ba9&scoped=true"
import script from "./WorkspaceSigChainRunCard.vue?vue&type=script&lang=js"
export * from "./WorkspaceSigChainRunCard.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceSigChainRunCard.vue?vue&type=style&index=0&id=42321ba9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42321ba9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42321ba9')) {
      api.createRecord('42321ba9', component.options)
    } else {
      api.reload('42321ba9', component.options)
    }
    module.hot.accept("./WorkspaceSigChainRunCard.vue?vue&type=template&id=42321ba9&scoped=true", function () {
      api.rerender('42321ba9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceSigChainRunCard.vue"
export default component.exports